<template>
    <div :id="$options.name">
        <transition name="fade">
            <div class="backdrop" v-if="states.shown" @click.prevent="states.shown = false"></div>
        </transition>
        <transition name="availability-modal">
            <div class="modal-container" v-if="states.shown">
                <div class="close" v-if="states.shown">
                    <a href="#" @click.prevent="states.shown = false">
                        <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABGUlEQVQ4T62VvUrFQBCFvwNa2PgoWlr5HLYqF7XyXaz8AVE7wdewuLa+jKDCyAmby+Zn1xiTIoFl9tszM2cnIj0RcQC8S/po16Z8I2IH2JP05nj5FRFHwAPwAqwkfU2EbQN3gPefSnpWUvYKbCXII3Au6bMGjQjDboGTFPcNHBq4C1wBxxnA0LOS0gS7sapszxNw2abcP81xo9ACbBPbAFMdDe2f2km/AHPtXaKm7hvgL9BVOtcNyNMc1LsDrEDvbQY7IKtZR1m7PgBWoHnTR2GDlPMdEWEbXfdUOcRqLyTZJoNnVGFSuRyw0M15KRdg85pSMe3fbVMxrRvQ3OvJxh656POv3uLDYfHxtfiAzabNf34B+5LWZv0An/+8labjkZQAAAAASUVORK5CYII=">
                    </a>
                </div>
                <div class="availability-checker">
                    <availability-checker :space="space" />
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
    import AvailabilityChecker from './availability-checker/AvailabilityChecker.vue';
    import moment from '../../modules/moment';

    export default {
        name: 'availability-modal',

        components: { AvailabilityChecker },

        props: ['space'],

        mixins: [AvailabilityChecker],

        filters: {
            // if date is today or tomorrow return these as the words
            // else return the date
            formattedDate(date) {
                const today = new moment().format('DD-MM-YYYY');
                const tomorrow = new moment().add(1, 'day').format('DD-MM-YYYY');
                if (date === today) {
                    return 'Today';
                }
                if (date === tomorrow) {
                    return 'Tomorrow';
                }
                return date;
            }
        },

        watch: {
            shown() {
                $('header').css({
                    zIndex: (this.shown) ? 1 : '',
                });
            }
        },

        data() {
            return {
                states: {
                    shown: false,
                },
            }
        },

        mounted() {
            window.bus
                .$off('showAvailabilityModal')
                .$on('showAvailabilityModal', () => {
                    this.states.shown = true;
                });
        },

        methods: {
            showArrivalDatepicker() {
                bus.$emit('openDatePicker', { id: 'landing-modal-start_date' });
            },

            showDepartureDatepicker() {
                bus.$emit('openDatePicker', { id: 'landing-modal-end_date' });
            },
        },
    }
</script>

<style lang="less" scoped>
    @import (reference) "~assets/less/variables.less";

    .availability-modal-enter-active,
    .availability-modal-leave-active {
        transition: .5s;
    }
    .availability-modal-enter,
    .availability-modal-leave-to {
        opacity: 0;
        transform: translate3d(0, 50px, 0);
    }


    .close {
        position: absolute;
        top: 8px;
        right: 0;
        opacity: 1;
        z-index: @zindex-modal + 1;
        a {
            display: block;
            padding: 17px;
        }
    }
    .backdrop {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #000000;
        opacity: 0.54;
        z-index: @zindex-modal;
        cursor: pointer;
    }
    .modal-container {
        padding: 10px;
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: @zindex-modal;
        max-height: 100%;
        overflow: auto;
        padding-top: 72px;
    }
    .availability-checker {
        border-radius: 4px;
        font-size: 14px;
        margin-bottom: 60px;
        position: relative;
    }
</style>


<style lang="less">
    @import (reference) "~assets/less/variables.less";

    #availability-modal {
        .availability-submit {
            position: absolute;
            top: 100%;
            left: -10px;
            right: -10px;
            margin-top: 0;
        }
        .location-availability {
            margin-bottom: 60px;

            &.whitelabel {
                margin-bottom: 0;
            }
        }
        .flatpickr-calendar {
            top: 25px !important;
            left: 0 !important;
            right: 0 !important;
            margin-right: auto;
            margin-left: auto;
        }
    }
</style>
